module.exports = __webpack_public_path__ + "img/entertainment-2.7ae6ba8f.jpg";